import { RootState } from 'editor/src/store/index';
import getAreaTokenForSpreadName from 'editor/src/store/livePreview/selector/getAreaTokenForSpreadName';

import coversPrintArea from 'editor/src/util/design/coversPrintArea';
import findSpreadGroundImage from 'editor/src/util/design/findSpreadGroundImage';

// A mask that does not cover the print area is a view mask, not a cut line —
// see coversPrintArea. Clipping to it would hide the artwork that prints out of
// the photo's shot, so those spreads get no mask at all.
const getSpreadMaskImage = (state: RootState, spreadName: string) => {
  const mask =
    findSpreadGroundImage(state.design.spreadMasks, spreadName) ??
    findSpreadGroundImage(state.design.spreadMasks, getAreaTokenForSpreadName(state, spreadName));

  return mask && coversPrintArea(mask) ? mask : undefined;
};

export default getSpreadMaskImage;
